import { STATUS_ICON_CHECK_O, STATUS_ICON_LOADING, STATUS_ICON_TIMES_O, STATUS_ICON_INACTIVE, STATUS_ICON_CLOCK } from '@/common/utils/statuses';
import computedLocale from '@/common/utils/computedLocale';
import i18n from '@/common/i18n';
import { MigrationDeployment } from '@schema';

export type DeploymentStatus = MigrationDeployment.status;
export const DeploymentStatus = MigrationDeployment.status;

/** Omitted from deployment status filter in self-service; shown in Admin (HCI) only. */
export const DEPLOYMENT_STATUSES_HIDDEN_IN_SSP: DeploymentStatus[] = [
  DeploymentStatus.CANCELED_FOR_DEBUGGING,
  DeploymentStatus.DEADLOCKED
];

export const DEPLOYMENT_STATUS_FILTER_PENDING_STATUSES: DeploymentStatus[] = [
  DeploymentStatus.UNEXECUTED,
  DeploymentStatus.PENDING
];

export const DEPLOYMENT_STATUS_TEXT = computedLocale<Record<DeploymentStatus, string>>(() => ({
  [DeploymentStatus.UNEXECUTED]: i18n.t('Pending'),
  [DeploymentStatus.PENDING]: i18n.t('Pending'),
  [DeploymentStatus.RUNNING]: i18n.t('Deploying'),
  [DeploymentStatus.CANCELLING]: i18n.t('Canceling'),
  [DeploymentStatus.COMPLETED]: i18n.t('Deployed'),
  [DeploymentStatus.ERROR]: i18n.t('Error'),
  [DeploymentStatus.CANCELED]: i18n.t('Canceled'),
  [DeploymentStatus.CANCELED_FOR_DEBUGGING]: i18n.t('Canceled for debugging'),
  [DeploymentStatus.DEADLOCKED]: i18n.t('Deadlocked')
}));

export const DEPLOYMENT_STATUS_ICON: Record<DeploymentStatus, string> = {
  [DeploymentStatus.UNEXECUTED]: STATUS_ICON_CLOCK,
  [DeploymentStatus.PENDING]: STATUS_ICON_CLOCK,
  [DeploymentStatus.RUNNING]: STATUS_ICON_LOADING,
  [DeploymentStatus.CANCELLING]: STATUS_ICON_LOADING,
  [DeploymentStatus.COMPLETED]: STATUS_ICON_CHECK_O,
  [DeploymentStatus.ERROR]: STATUS_ICON_TIMES_O,
  [DeploymentStatus.CANCELED]: STATUS_ICON_INACTIVE,
  [DeploymentStatus.CANCELED_FOR_DEBUGGING]: STATUS_ICON_INACTIVE,
  [DeploymentStatus.DEADLOCKED]: STATUS_ICON_TIMES_O
};
